var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDelayed)?_c('ckeditor',_vm._b({attrs:{"value":_vm.value || '',"editor":_vm.editor,"config":_vm.config},on:{"input":function($event){return _vm.$emit('input', $event)}}},'ckeditor',_vm.ckeditorVue,false)):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }